import React, { useEffect } from "react";
import Styles from "./InfoExchanged.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentHistory } from "../../../../Redux/Slices/bankingSlice";
import { uploadLedgerFile } from "../../../../Services/ApiCalling/banking";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import Loader from "../../../../commons/Loader/Loader";

const InfoExchanged = ({ open, handleClose, connectionId, listingId }) => {
  const dispatch = useDispatch();

  const { documentHistory, loading, error } = useSelector(
    (state) => state.bankingSlice
  );

  useEffect(() => {
    if (connectionId) {
      dispatch(fetchDocumentHistory({ connectionId, documentType: "RANDOM" }));
    }
  }, [dispatch, connectionId]);

  const handleViewDoc = (path) => {
    const fileUrl = `${process.env.REACT_APP_API_URL}/${path}`;
    window.open(fileUrl, "_blank", "noopener");
  };

  const handleUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".pdf";
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);

      try {
        await uploadLedgerFile(formData, connectionId, listingId);
        dispatch(
          fetchDocumentHistory({ connectionId, documentType: "RANDOM" })
        );
      } catch (err) {
        console.error("File upload failed:", err);
      }
    };
    input.click();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.createEditModalCont}`}>
        <div
          className={`display_flex_row modalHeading  ${Styles.modalHeading}`}
        >
          <div className="headingText">Information Exchanged</div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>

        <div className={Styles.docContainer}>
          <div className={`${Styles.docHeaderRow} ${Styles.docRow1}`}>
            <div className={`${Styles.docCol} ${Styles.filename}`}>
              File Name
            </div>
            <div className={`${Styles.docCol} ${Styles.createdAt}`}>
              Uploaded On
            </div>
          </div>

          <div className={Styles.docContentScroll}>
            {loading ? (
              <div className={Styles.loadingRow}>
                <Loader />
              </div>
            ) : error ? (
              <p className={Styles.error}>{error}</p>
            ) : documentHistory?.length > 0 ? (
              documentHistory.map((doc) => (
                <div className={Styles.docRow} key={doc.id}>
                  <div
                    className={`${Styles.docCol} ${Styles.filename} ${Styles.docContent}`}
                  >
                    {doc.filename}
                  </div>
                  <div
                    className={`${Styles.docCol} ${Styles.createdAt} ${Styles.docContent}`}
                  >
                    {new Date(doc.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                    <span
                      onClick={() => handleViewDoc(doc.path)}
                      className={Styles.viewLink}
                      style={{ cursor: "pointer" }}
                    >
                      <ViewIcon />
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p>No document history found.</p>
            )}
          </div>
        </div>

        <div className={Styles.uploadButton}>
          <div className={Styles.uploadBtn} onClick={handleUpload}>
            Upload
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InfoExchanged;
